export default {
  widgetTitleMultiFacteur: 'MULTIFACTOR AUTHENTICATION',
  widgetTitleOktaVerify: 'OKTA VERIFY IDENTIFICATION',
  widgetTitleWindowsHello: 'WINDOWS HELLO',
  widgetTitleGoogleAuthenticator: 'GOOGLE AUTHENTICATOR IDENTIFICATION',
  widgetTitlePhoneAuthenticator: 'PHONE IDENTIFICATION',
  widgetTitleBiometricAuthenticator: 'BIOMETRIC AUTHENTICATOR IDENTIFICATION',
  widgetTitleAppAuthenticator: 'MOBILE APP IDENTIFICATION',
  widgetTitleExpiredPassword: 'Temporary Password',
  widgetTitleConnexion: 'Client Portal',
};
